module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0022.332d7b96.jpg";